export const EVENT_RES_MS = 20;
